import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TournamentDetail"] */ "/vercel/path0/components/tournaments/detail.tsx");
